import { render, staticRenderFns } from "./SupportCBRC.vue?vue&type=template&id=3e9e222f&scoped=true&"
import script from "./SupportCBRC.vue?vue&type=script&lang=js&"
export * from "./SupportCBRC.vue?vue&type=script&lang=js&"
import style0 from "./SupportCBRC.vue?vue&type=style&index=0&id=3e9e222f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9e222f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VSnackbar})
